var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none rounded",class:_vm.state.color},[_vm._v("\n    "+_vm._s(_vm.state.nome)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }